import React from "react";
import "../../Styles/certified/elixir.css";

export default function Finzly() {
  return (
    <>
      <div className="elixir-certified-details-section">
        <div className="elixir-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="elixir-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="elixir-certified-details-left">
            <img
              src="/assets/elix/adam_ribbon.png"
              alt="Outstanding Workplaces Certified"
              className="elixir-certified-badge"
            />
            <div className="elixir-certified-company-names">
              <a href="https://www.elixirglobal.com/" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/elix/elix_logo.png"
                alt="Walkzero Logo"
                className="elixir-certified-company-logo"
              />
            </a>
              <h1 className="elixir-certified-full-name">
              Elixir Global
              </h1>
            </div>
          </div>
          
        </div>
        {/* Description section below */}
        <div className="elixir-certified-description">
          <h2>
            Why Elixir Global is an Outstanding Workplaces
          </h2>
          <p>
          Elixir Global operates at the intersection of enterprise platform delivery and AI deployment. We have been delivering transformation for 20 years across consulting, digital transformation, and intelligent operations. Elixir Global Brand operates under Elixir Business Support Solutions legal entity. The firm spans specialised businesses across AI, SAP, HR, finance, and retail, with a global partner ecosystem and a team of certified consultants and engineers across the Gulf, India, Singapore, and North America.

          </p>
        </div>
        {/* Info Cards Section */}
        <div className="elixir-certified-info-cards">
          <div className="elixir-certified-info-card">
            <div className="elixir-certified-info-title">COMPANY SIZE</div>
            <div className="elixir-certified-info-value">700-1500 Employees</div>
          </div>
          <div className="elixir-certified-info-card">
            <div className="elixir-certified-info-title">INDUSTRY</div>
            <div className="elixir-certified-info-value">Strategy, Consulting and Digital Transformation

</div>
          </div>
          <div className="elixir-certified-info-card">
            <div className="elixir-certified-info-title">CONNECT</div>
            <div className="elixir-certified-info-icons">
              <span className="elixir-certified-icon-round">
                <a href="https://www.elixirglobal.com/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="elixir-certified-icon-round">
                <a href="https://www.linkedin.com/company/elixirglobal/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="elixir-certified-icon-round">
                <a href="https://www.facebook.com/elixirglobal/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
            </div>
          </div>
          <div className="elixir-certified-info-card">
            <div className="elixir-certified-info-title">LOCATION (HQ)</div>
            <div className="elixir-certified-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="elixir-certified-recognition-section">
          <h2 className="elixir-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="elixir-certified-recognition-badge">
            <img
              src="/assets/elix/adam_ribbon.png"
              alt="Outstanding Workplaces Certified"
              className="elixir-certified-recognition-image"
            />
          </div>
          <div className="elixir-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        
      </div>
    </>
  );
}
